import { EditPenIcon, TrashRoundedIcon, WindQA } from '~/icons';
import {
  ActionButtons,
  Container,
  ContentWrapper,
  Divider,
  InfoColumn,
  Label,
  StatusColor,
  Temperature,
  TooltipContainer,
  TooltipText,
  Value,
} from './styles';
import { UnitMapPointsResponseData } from '~/metadata/UnitMap.model';
import { colors } from '~/styles/colors';
import { useUnitMap } from '~/pages/Analysis/Units/UnitProfile/UnitMap/UnitMapContext';
import { t } from 'i18next';
import { shouldHideDutQaTemperature } from '~/helpers/dutQa';

interface PinProps {
  pin: UnitMapPointsResponseData;
  handleEditPin: (pinId: number) => void
  hideTemp: boolean
}

export const Pin: React.FC<PinProps> = ({ pin, handleEditPin, hideTemp }) => {
  const {
    removePin,
    isShowList,
  } = useUnitMap();
  const hideTemperature = shouldHideDutQaTemperature(pin, hideTemp);

  const handleGetStatusColor = (pin) => {
    const colorsOption = {
      blue: colors.BlueSecondary,
      red: colors.RedDark,
      green: colors.GreenLight,
      gray: '#B4B4B4',
    };

    const limits = [pin.TUSEMIN, pin.TUSEMAX];
    if (hideTemperature) return colorsOption.gray;
    if (limits.every((limit) => limit === null || limit === undefined)) return colorsOption.gray;

    if (pin.TEMPERATURE === null || pin.TEMPERATURE === undefined) return colorsOption.gray;

    if (pin.TEMPERATURE < pin.TUSEMIN) return colorsOption.blue;

    if (pin.TEMPERATURE >= pin.TUSEMIN && pin.TEMPERATURE <= pin.TUSEMAX) return colorsOption.green;

    if (pin.TEMPERATURE > pin.TUSEMAX) return colorsOption.red;

    return colorsOption.gray;
  };

  const handleGetPinTemperature = (pin) => {
    if (pin.TEMPERATURE || pin.TEMPERATURE === 0) return pin.TEMPERATURE;

    return '-';
  };

  const getColorDutQA = (co2, humidity, limHMax, limHMin, limCo2) => {
    if ((humidity && limHMax && humidity > limHMax) || (co2 && limCo2 && co2 > limCo2)) return colors.RedDark;
    if (humidity && limHMin && humidity < limHMin) return colors.BlueSecondary;
    return '#B4B4B4';
  };
  return (
    <TooltipContainer
      viewMode={isShowList}
      onClick={() => {
        if (isShowList) {
          window.open(`/analise/dispositivo/${pin.DEVICE_CODE}/informacoes`, '_blank', 'noopener');
        }
      }}
    >
      <TooltipText viewMode={isShowList} isQA={hideTemperature}>
        <ContentWrapper viewMode={isShowList} haveOverflow={pin.ROOM_NAME?.length > 17}>
          {!isShowList && <span className="marquee">{pin.ROOM_NAME}</span>}
          <Temperature>
            {!hideTemperature ? (
              <>
                <StatusColor color={handleGetStatusColor(pin)} />
                <span>
                  {handleGetPinTemperature(pin)}
                  <span className="unit">°C</span>
                </span>
              </>
            ) : (
              <Container>
                <WindQA color={getColorDutQA(pin.eCO2, pin.HUMIDITY, pin.HUMIMAX, pin.HUMIMIN, pin.CO2MAX)} />
                <InfoColumn>
                  <Label>{t('umidade')}</Label>
                  <Value>
                    {pin.HUMIDITY}
                    <span className="unit">%</span>
                  </Value>
                </InfoColumn>
                <Divider />
                <InfoColumn>
                  CO2
                  <Value>
                    <span>{pin.eCO2}</span>
                    <span className="unit">ppm</span>
                  </Value>
                </InfoColumn>
              </Container>
            )}
          </Temperature>
        </ContentWrapper>
        {!isShowList && (
          <ActionButtons>
            <EditPenIcon handleClick={() => handleEditPin(pin.DEVICE_ID)} />
            <TrashRoundedIcon handleClick={() => removePin(pin.DEVICE_ID)} />
          </ActionButtons>
        )}
      </TooltipText>
    </TooltipContainer>
  );
};
